import { Types } from "../../actions/user/resetPassword.actions";

const INITIAL_STATE = {
  success: false,
  loading: false,
  error: null
};

export default function resetPassword(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.RESET_PASSWORD: {
      return {
        ...state,
        ...INITIAL_STATE,
        loading: true
      };
    }

    case Types.RESET_PASSWORD_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    }

    case Types.RESET_PASSWORD_SUCCESS: {
      return {
        ...state,
        loading: false,
        success: true
      };
    }

    case Types.RESET_PASSWORD_RESET: {
      return {
        ...state,
        ...INITIAL_STATE
      };
    }

    default:
      return state;
  }
}
